import { render, staticRenderFns } from "./ArticlePreview.vue?vue&type=template&id=1f01f308&scoped=true&"
import script from "./ArticlePreview.vue?vue&type=script&lang=js&"
export * from "./ArticlePreview.vue?vue&type=script&lang=js&"
import style0 from "./ArticlePreview.vue?vue&type=style&index=0&id=1f01f308&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f01f308",
  null
  
)

export default component.exports